const KNOWN_PREFIXES = [ 'coverage.', 'policy.', 'carrier.', 'nonextraction.' ];

/**
 * Fallback humanizer for a raw criterion field path (e.g. `coverage.amBestFinancialStrengthRating`).
 * Used when the exact configured criterion title cannot be resolved from the criterion templates.
 * Strips the known prefix, takes the final path segment, and converts camelCase to Title Case
 * (e.g. `coverage.amBestFinancialStrengthRating` -> `Am Best Financial Strength Rating`).
 */
export function humanizeCriterionField(field: string): string {
    let path = field;
    for (const prefix of KNOWN_PREFIXES) {
        if (path.startsWith(prefix)) {
            path = path.slice(prefix.length);
            break;
        }
    }
    const lastSegment = path.split('.').pop() || path;
    return lastSegment
        .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
        .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
        .replace(/^./, (char) => char.toUpperCase())
        .trim();
}
